import { MeterGroup } from 'primereact/metergroup';
import { useEffect, useState } from 'react';
import { MeterOption } from '../../models/MeterOption';
import { MeterTemplateWeekly } from './MeterTemplateWeekly';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import {
  DashboardGetWeeklySnapshotQuery,
  DashboardGetWeeklySnapshotQuery$data,
} from '../../graphQLOperations/__generated__/DashboardGetWeeklySnapshotQuery.graphql';
import { getWeeklySnapshotInfo } from '../../graphQLOperations/Dashboard';
import { CustomBranding, mapCustomBranding } from '../../models/User';
import { selectUser } from '../../redux/reducers/userSlice';
import { useAppSelector } from '../../redux/hooks';
import { EmptyResultsWidgets, FilterOptionValues } from './TeacherDashboard';
// import { getPositionToSkillGoalTooltip } from '../../businessLogicService/getPositionToSkillGoalTooltip';

const order = ['N/A', '0', '1', '2', '3'];
const classNames: { [key: string]: string } = {
  'N/A': 'c-not-started',
  '0': 'c-light',
  '1': 'c-blue-100',
  '2': 'c-info',
  '3': 'c-lapiz-blue',
};

interface Props {
  queryReference: PreloadedQuery<DashboardGetWeeklySnapshotQuery, Record<string, unknown>>;
  filterOption: FilterOptionValues;
  setEmptyResult: React.Dispatch<React.SetStateAction<EmptyResultsWidgets>>;
}

const WeeklyMeterGroup = ({ queryReference, filterOption, setEmptyResult }: Props) => {
  const data = usePreloadedQuery<DashboardGetWeeklySnapshotQuery>(getWeeklySnapshotInfo, queryReference);
  const userRedux = useAppSelector(selectUser);
  const miamiBrand =
    userRedux?.network?.customBranding &&
    mapCustomBranding[userRedux?.network?.customBranding] === CustomBranding.MIAMI;

  const [meterValues, setMeterValues] = useState<MeterOption[]>([]);

  useEffect(() => {
    if (data.studentsSkillAssessmentsWeeklySnapshot.every(el => el.uniqueSkillsPassed === null)) {
      setEmptyResult(prev => ({ ...prev, weeklySnapshot: true }));
    } else {
      setEmptyResult(prev => ({ ...prev, weeklySnapshot: false }));
      meterGroupData(data);
    }
  }, [data]);

  const meterGroupData = (data: DashboardGetWeeklySnapshotQuery$data) => {
    const totalStudents = data.studentsSkillAssessmentsWeeklySnapshot.reduce((acc, el) => acc + el.numberOfStudents, 0);
    const values: MeterOption[] = data.studentsSkillAssessmentsWeeklySnapshot
      .filter(i => i.numberOfStudents > 0)
      .map(item => {
        const width = (item.numberOfStudents * 100) / Math.floor(totalStudents);
        const label =
          item.uniqueSkillsPassed !== null && item.uniqueSkillsPassed !== undefined
            ? String(item.uniqueSkillsPassed < 3 ? item.uniqueSkillsPassed : 3)
            : 'N/A';
        const element: MeterOption = {
          label,
          value: width,
          width,
          className: classNames[label],
          score: item.uniqueSkillsPassed,
          students: item.numberOfStudents,
          passed: item.uniqueSkillsPassed,
          values: [],
          percentages: [0],
          totaLPercent: 0,
        };
        return element;
      });

    values.sort((a, b) => order.indexOf(a.label) - order.indexOf(b.label));
    setMeterValues(values);
  };

  // Hide Skill Goal Chip
  // const startTemplate = ({ values }: CustomRenderProps) => {
  //   const existLabelTwo = values.find(el => el.label === '2');
  //   const { positionOfTooltip } = getPositionToSkillGoalTooltip(values);

  //   return (
  //     <div className="mt-2 mb-2 relative flex flex-direction-row align-items-center overflow-x-auto">
  //       <h4 className={`${miamiBrand && 'pb-2'} width-auto text-left`} style={{ width: '38%' }}>{`${
  //         miamiBrand ? 'Skill Challenges passed (80-100%)' : 'Skills Passed'
  //       }`}</h4>
  //       {existLabelTwo?.width && existLabelTwo?.width > 0 && (
  //         <span style={{ width: positionOfTooltip + '%' }}>
  //           <div className="nc_teacher-dashboard-skill-goal-tootip">
  //             <div>
  //               <span className="nc_icon-nc_challenge icon-sm"></span>
  //               <p>
  //                 <span className="font-semibold">Skill Goal:</span> 2 new skills
  //               </p>
  //               <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8" fill="none">
  //                 <path
  //                   d="M5.43262 7.25C5.24013 7.5831 4.75987 7.5831 4.56738 7.25L1.10254 1.25C0.910248 0.916693 1.15129 0.5 1.53613 0.5L8.46387 0.5C8.84871 0.5 9.08975 0.916691 8.89746 1.25L5.43262 7.25Z"
  //                   fill="white"
  //                   stroke="#B0C6F6"
  //                 />
  //               </svg>
  //             </div>
  //           </div>
  //         </span>
  //       )}
  //     </div>
  //   );
  // };

  return (
    <div className="w-12">
      <h2
        className={`${miamiBrand ? 'pb-2' : ''} width-auto text-left m-0 text-base font-bold leading-6 tw-not-italic`}
      >
        New Skills Passed via Skill Challenge
      </h2>
      <div className="w-full" id="WeeklySnapshotBar">
        <MeterGroup
          className="nc_metergroup w-full nc_metergroup-wide mb-3"
          values={meterValues}
          labelPosition="start"
          // start={startTemplate}
          meter={met => (
            <MeterTemplateWeekly
              filterOption={filterOption}
              key={(met as MeterOption).label}
              value={met as MeterOption}
            />
          )}
        />
      </div>
    </div>
  );
};

export default WeeklyMeterGroup;
